module.exports = " <a class=vc-icon-button href=javascript:; :class=buttonClass v-el:button> <icon :value=icon></icon> <ripple :trigger=$els.button></ripple> </a> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/icon/iconButton.vue
 ** module id = 449
 ** module chunks = 1
 **/